import React from "react";
import DesktopImg from "../../assets/ThreeDprinting/FDM Capabilities/Desktop Img.webp";

function FDMCapabilities() {
  return (
    <div className="threeD-printing-fdm-capabilities">
      <h2>
        FDM <span>Capabilities</span>
      </h2>
      <div className="threeD-printing-fdm-capabilities-container">
        <div className="threeD-printing-fdm-capabilities-info">
          <div className="threeD-printing-fdm-capabilities-text">
            <h3>Maximum Build Volume</h3>
            <section>
              <h4>450 x 450 x 470 mm</h4>
              <p>
                Parts shall be split, printed seperately and fused together to
                form much larger volumes
              </p>
            </section>
          </div>
          <ul>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
              >
                <g clipPath="url(#clip0_233_11956)">
                  <path
                    d="M22.1992 7.35547V23.3555M22.1992 7.35547L20.1992 9.35547M22.1992 7.35547L24.1992 9.35547M22.1992 23.3555L24.1992 21.3555M22.1992 23.3555L20.1992 21.3555M17.6992 2.85547H1.69922M17.6992 2.85547L15.6992 0.855469M17.6992 2.85547L15.6992 4.85547M1.69922 2.85547L3.69922 4.85547M1.69922 2.85547L3.69922 0.855469M16.6992 7.35547H2.69922C2.09922 7.35547 1.69922 7.75547 1.69922 8.35547V22.3555C1.69922 22.9555 2.09922 23.3555 2.69922 23.3555H16.6992C17.2992 23.3555 17.6992 22.9555 17.6992 22.3555V8.35547C17.6992 7.75547 17.2992 7.35547 16.6992 7.35547Z"
                    stroke="#FFBF00"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12.1992 7.35547H7.19922V13.3555H12.1992V7.35547Z"
                    stroke="#FFBF00"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_233_11956">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(0.949219 0.105469)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <p>
                Printing Accuracy:<span> 0.1mm</span>
              </p>
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
              >
                <path
                  d="M12.9492 21.1055C14.1311 21.1055 15.3014 20.8727 16.3934 20.4204C17.4853 19.9681 18.4775 19.3052 19.3132 18.4694C20.1489 17.6337 20.8118 16.6416 21.2641 15.5496C21.7164 14.4577 21.9492 13.2874 21.9492 12.1055C21.9492 10.9236 21.7164 9.75325 21.2641 8.66132C20.8118 7.56939 20.1489 6.57723 19.3132 5.74151C18.4775 4.90578 17.4853 4.24285 16.3934 3.79055C15.3014 3.33826 14.1311 3.10547 12.9492 3.10547C10.5623 3.10547 8.27309 4.05368 6.58526 5.74151C4.89743 7.42933 3.94922 9.71852 3.94922 12.1055C3.94922 14.4924 4.89743 16.7816 6.58526 18.4694C8.27309 20.1573 10.5623 21.1055 12.9492 21.1055ZM23.9492 12.1055C23.9492 18.1805 19.0242 23.1055 12.9492 23.1055C6.87422 23.1055 1.94922 18.1805 1.94922 12.1055C1.94922 6.03047 6.87422 1.10547 12.9492 1.10547C19.0242 1.10547 23.9492 6.03047 23.9492 12.1055ZM15.9492 16.5195L11.9492 12.5195V5.60547H13.9492V11.6915L17.3632 15.1055L15.9492 16.5195Z"
                  fill="#FFBF00"
                />
              </svg>
              <p>
                Standard Lead Time: <span>2-3 Business Days</span>
              </p>
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
              >
                <path
                  d="M18.5202 18.1055H21.3492C21.5083 18.1055 21.661 18.0423 21.7735 17.9297C21.886 17.8172 21.9492 17.6646 21.9492 17.5055V11.1055C21.9492 10.0446 21.5278 9.02719 20.7776 8.27704C20.0275 7.5269 19.0101 7.10547 17.9492 7.10547H7.94922C6.88835 7.10547 5.87094 7.5269 5.12079 8.27704C4.37065 9.02719 3.94922 10.0446 3.94922 11.1055V17.5055C3.94922 17.6646 4.01243 17.8172 4.12495 17.9297C4.23748 18.0423 4.39009 18.1055 4.54922 18.1055H7.37822M8.94922 7.10547V3.70547C8.94922 3.54634 9.01243 3.39373 9.12495 3.2812C9.23748 3.16868 9.39009 3.10547 9.54922 3.10547H16.3492C16.5083 3.10547 16.661 3.16868 16.7735 3.2812C16.886 3.39373 16.9492 3.54634 16.9492 3.70547V7.10547"
                  stroke="#FFBF00"
                  strokeWidth="1.5"
                />
                <path
                  d="M7.04731 20.4205L7.37731 18.1055L7.87531 14.6205C7.89577 14.4775 7.9671 14.3467 8.07621 14.2521C8.18533 14.1575 8.3249 14.1055 8.46931 14.1055H17.4293C17.5737 14.1055 17.7133 14.1575 17.8224 14.2521C17.9315 14.3467 18.0029 14.4775 18.0233 14.6205L18.5193 18.1055L18.8503 20.4205C18.8625 20.5056 18.8562 20.5923 18.832 20.6748C18.8077 20.7573 18.766 20.8336 18.7097 20.8986C18.6533 20.9635 18.5837 21.0156 18.5055 21.0513C18.4273 21.087 18.3423 21.1055 18.2563 21.1055H7.64131C7.55533 21.1055 7.47035 21.087 7.39213 21.0513C7.31392 21.0156 7.24428 20.9635 7.18796 20.8986C7.13163 20.8336 7.08992 20.7573 7.06565 20.6748C7.04139 20.5923 7.03513 20.5056 7.04731 20.4205Z"
                  stroke="#FFBF00"
                  strokeWidth="1.5"
                />
                <path
                  d="M17.9492 10.1155L17.9592 10.1045"
                  stroke="#FFBF00"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p>Multicolor Printing</p>
            </li>
          </ul>
        </div>
        <div className="threeD-printing-fdm-capabilities-img">
            <img src={DesktopImg} alt="FDM capabilities" />
        </div>
      </div>
    </div>
  );
}

export default FDMCapabilities;
